import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { cloneElement, forwardRef, useMemo, } from 'react';
import MuiStepButton from '@material-ui/core/StepButton';
import { combineClasses, combineProps, isRcElement, styled, useThemeProps, } from '../../../foundation';
import { RcStepLabel } from '../StepLabel';
import { StepButtonStyle } from './styles';
import { RcStepButtonClasses } from './utils';
var _RcStepButton = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcStepButton' });
    var classesProp = props.classes, childrenProp = props.children, icon = props.icon, optional = props.optional, error = props.error, StepLabelProps = props.StepLabelProps, editable = props.editable, rest = __rest(props, ["classes", "children", "icon", "optional", "error", "StepLabelProps", "editable"]);
    var classes = useMemo(function () { return combineClasses(RcStepButtonClasses, classesProp); }, [classesProp]);
    var children = useMemo(function () {
        var childProps = combineProps({
            icon: icon,
            optional: optional,
            error: error,
            StepIconProps: { editable: editable },
        }, StepLabelProps);
        return isRcElement(childrenProp, ['RcStepLabel']) ? (cloneElement(childrenProp, childProps)) : (React.createElement(RcStepLabel, __assign({}, childProps), childrenProp));
    }, [StepLabelProps, childrenProp, editable, error, icon, optional]);
    return (React.createElement(MuiStepButton, __assign({}, rest, { icon: icon, optional: optional, ref: ref, classes: classes }), children));
});
var RcStepButton = styled(_RcStepButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), StepButtonStyle);
RcStepButton.defaultProps = {
    alternativeLabel: true,
};
RcStepButton.displayName = 'RcStepButton';
export { RcStepButton };
var templateObject_1;
